<div *ngIf="message && message !== null" class="container-fluid padding-0">
  <div class="row padding-0">
    <div class="col-12 padding-0">
      <h1 *ngIf="message?.msgTitle" mat-dialog-title class="text-center">
        {{ message?.msgTitle }}
      </h1>
      <div *ngIf="message?.msgBegin && message?.msgBegin !== ''" class="text-center padding-0">
        {{ isoFormatDMY(parseISOString(message?.msgBegin), message?.msgBegin) }}
      </div>
      <div mat-dialog-content class="sublist-hr">
        <div
          *ngIf="message?.msgText && message?.msgText !== ''"
          [innerHTML]="message?.msgText"
        ></div>
        <div class="text-center">
          <a
            *ngIf="message?.msgLinkText && message?.msgLinkText !== ''"
            class="main-link"
            tabindex="0"
            (click)="openLink()"
            (keyup.enter)="openLink()"
            >{{ message?.msgLinkText }}</a
          >
        </div>
        <div *ngIf="message?.msgSignature && message?.msgSignature !== ''" class="sublist-hr">
          {{ message?.msgSignature }}
        </div>
      </div>
      <div mat-dialog-actions class="example-card float-end">
        <button mat-button type="button" (click)="close()" cdkFocusInitial>Ok</button>
      </div>
    </div>
  </div>
</div>
